<template>
  <b-modal size="lg" ref="edit-sub-category" id="edit-sub-category" hide-footer hide-header centered>
    <h2 class="text-center my-4">Alkategória szerkesztése</h2>

    <EditSubCategoryForm :category="category" @patched-sub-category="forwardPatchEvent" />
  </b-modal>
</template>

<script>
import EditSubCategoryForm from '../../../../components/EditSubCategoryForm.vue'
export default {
  props: {
    category: { type: Object, required: true }
  },
  methods: {
    forwardPatchEvent(patchedCategory) {
      this.$emit('patched-sub-category', patchedCategory)
      this.$bvModal.hide('edit-sub-category')
    }
  },
  components: {
    EditSubCategoryForm
  }
}
</script>

<style lang="scss" scoped></style>
